import type { Locale } from '@shared/libs';
import { Text2, Int1 } from '@shared/ui';

import styles from './guarantees.module.css';

const Guarantees = ({ locale }: { locale: Locale }) => {
  return (
    <div className={styles.container}>
      <Text2 className={styles.title} html={locale.GUARANTEE_TITLE} />
      <Int1 className={styles.text}>{locale.GUARANTEE_TEXT}</Int1>
    </div>
  );
};

export default Guarantees;
